// extracted by mini-css-extract-plugin
export default {"root":"Separator_root__naSxr"};